import React, { useEffect, useState } from 'react';
import { Container, Button, Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap';
import RelaisServices from '../../services/RelaisServices';
import UserServices from '../../services/UserServices';

const initialRelayState = { id: null, name: '', slug: '', overview: '', address: '', created_by: '' };

const Relais = () => {
    const [relays, setRelays] = useState([]);
    const [users, setUsers] = useState([]);
    const [relay, setRelay] = useState(initialRelayState);
    const [modal, setModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [relayToDelete, setRelayToDelete] = useState(null);
    const [message, setMessage] = useState("");
    const [alert, setAlert] = useState("");

    useEffect(() => {
        RelaisServices.getRelais().then(data => {
            setRelays(data['data']);
        });
        UserServices.getUsers().then(data => {
            setUsers(data['data']);
        });
    }, []);

    const showUserName = (userId) => {
        const user = users.filter((u) => u.id === userId);
        let element;
        if (typeof user[0] !== 'undefined') {
            element = user[0];
        } else {
            element = {
                first_name: " ",
                last_name: " "
            }
        }
        return `${element.first_name} ${element.last_name}`
    };

    const toggle = () => setModal(!modal);
    const toggleDeleteModal = () => setDeleteModal(!deleteModal);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setRelay({ ...relay, [name]: value });
    };

    const addRelay = () => {
        if(!relay.name || !relay.address){
            setAlert("Les champs Nom et adresses sont obligatoires");
            // Si les champs name ou address ne sont pas renseignés, afficher un message d'erreur ou empêcher l'appel à addRelais
            return;
        }
        let relaisToAdd = { id: relays.length + 1, name: relay.name, slug: relay.slug, overview: relay.overview, address: relay.address, created_by: parseInt(localStorage.getItem('created_by')) };
        RelaisServices
            .addRelais(relaisToAdd)
            .then(data => {
                setAlert("");
                if (data['success'] === true) {
                    setRelays([...relays, relaisToAdd]);
                    setRelay(initialRelayState);
                    toggle();
                    setMessage("Relais ajouté avec succès !");
                } else if (data['success'] === false) {
                    setMessage("");
                    setAlert(data['message']);
                }
            });
    };

    const deleteRelay = (relayToDelete) => {
        RelaisServices
            .deleteRelais(relayToDelete)
            .then(data => {
                console.log(data);
                setAlert("");
                if (data['success'] === true) {
                    setRelays(relays.filter((relay) => relay.id !== relayToDelete.id));
                    setRelayToDelete(null);
                    toggleDeleteModal();
                    setMessage("Relais supprimé avec succès !");
                } else if (data['success'] === false) {
                    setMessage("");
                    setAlert(data['message']);
                }
            });
    };

    const editRelay = (relay) => {
        setRelay(relay);
        toggle();
    };

    const updateRelay = () => {
        RelaisServices
            .updateRelais(relay)
            .then(data => {
                setAlert("");
                if (data['success'] === true) {
                    setRelays(relays.map((r) => (r.id === relay.id ? relay : r)));
                    setRelay(initialRelayState);
                    toggle();
                    setMessage("Relais modifié avec succès !");
                } else if (data['success'] === false) {
                    setMessage("");
                    setAlert(data['message']);
                }
            });
    };

    const confirmDeleteRelay = (relay) => {
        setRelayToDelete(relay);
        toggleDeleteModal();
    };

    return (
        <Container>
            <h1 className='mb-5'>Liste des relais</h1>

            {message && <div className="alert alert-success mt-1">{message}</div>}
            {alert && <div className="alert alert-danger mt-1">{alert}</div>}
            <Button color='primary' onClick={toggle}>
                Ajouter un relais
            </Button>
            <Table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Nom*</th>
                        <th>Adresse*</th>
                        <th>Aperçu</th>
                        <th>Créé par</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {relays.map((relay) => (
                        <tr key={relay.id}>
                            <td>{relay.id}</td>
                            <td>{relay.name}</td>
                            <td>{relay.address}</td>
                            <td>{relay.overview}</td>
                            <td>{showUserName(relay.created_by)}</td>
                            <td>
                                <Button color='info' onClick={() => editRelay(relay)}>
                                    Modifier
                                </Button>{' '}
                                <Button color='danger' onClick={() => confirmDeleteRelay(relay)}>
                                    Supprimer
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>{relay.id ? 'Modifier le relais' : 'Ajouter un relais'}</ModalHeader>
                <ModalBody>
                    <div className='form-group'>
                        <label htmlFor='name'>Nom</label>
                        <input type='text'
                         className='form-control'
                          id='name'
                           name='name'
                            value={relay.name} 
                            onChange={handleInputChange}
                            required={true} />
                    </div>
                    <div className='form-group'>
                        <label htmlFor='address'>Adresse</label>
                        <input type='text'
                         className='form-control'
                          id='address'
                           name='address'
                            value={relay.address} 
                            onChange={handleInputChange}
                            required={true} />
                    </div>
                    <div className='form-group'>
                        <label htmlFor='overview'>Aperçu</label>
                        <input type='text'
                         className='form-control'
                          id='overview' 
                          name='overview'
                           value={relay.overview}
                            onChange={handleInputChange} />
                    </div>
                </ModalBody>
                <ModalFooter>
                    {relay.id ? (
                        <Button color='primary' onClick={updateRelay}>
                            Modifier
                        </Button>
                    ) : (
                        <Button color='primary' onClick={addRelay}>
                            Ajouter
                        </Button>
                    )}{' '}
                    <Button color='secondary' onClick={toggle}>
                        Annuler
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={deleteModal} toggle={toggleDeleteModal}>
                <ModalHeader toggle={toggleDeleteModal}>Confirmation de suppression</ModalHeader>
                <ModalBody>
                    Êtes-vous sûr de vouloir supprimer le relais {relayToDelete?.name} ?
                </ModalBody>
                <ModalFooter>
                    <Button color='danger' onClick={() => deleteRelay(relayToDelete)}>
                        Supprimer
                    </Button>{' '}
                    <Button color='secondary' onClick={toggleDeleteModal}>
                        Annuler
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
};

export default Relais;
